import React from 'react';
export const ProductImageWithFallbacks = ({ src, className, id }) => {
    const [idx, setIdx] = React.useState(0);
    if (src === null || src === void 0 ? void 0 : src[idx]) {
        return (React.createElement("img", { src: src[idx], "aria-hidden": true, onError: () => setIdx((cur) => cur + 1), className: className === null || className === void 0 ? void 0 : className[idx], id: id }));
    }
    return null;
};
ProductImageWithFallbacks.displayName = 'ProductImageWithFallbacks';
//# sourceMappingURL=ProductImageWithFallbacks.js.map